import { c as _c } from "react/compiler-runtime";
import { ComponentBlocksTwoColumnLayout, Maybe } from "@lib/generated/graphql";
import clsx from "clsx";
import React, { ElementType, FC, PropsWithChildren } from "react";
export interface TwoColumnLayoutProps<T extends ElementType = "div"> {
  data?: Maybe<ComponentBlocksTwoColumnLayout>;
  as?: T;
}
export interface TwoColumnLayoutColumnProps {
  data?: Maybe<ComponentBlocksTwoColumnLayout>;
  className?: string;
}
const getColClass = (cols: number) => `col-span-${cols}`;
const FirstColumn: FC<PropsWithChildren<TwoColumnLayoutColumnProps>> = t0 => {
  const $ = _c(7);
  const {
    data,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== data?.direction || $[2] !== data?.firstColumn) {
    t1 = clsx(className, getColClass(data?.firstColumn || 6), {
      "col-end-13": data?.direction === "reverse",
      "col-start-1": data?.direction === "normal"
    });
    $[0] = className;
    $[1] = data?.direction;
    $[2] = data?.firstColumn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const SecondColumn: FC<PropsWithChildren<TwoColumnLayoutColumnProps>> = t0 => {
  const $ = _c(7);
  const {
    data,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== data?.direction || $[2] !== data?.secondColumn) {
    t1 = clsx(className, getColClass(data?.secondColumn || 6), {
      "col-end-13": data?.direction === "normal",
      "col-start-1 row-start-1": data?.direction === "reverse"
    });
    $[0] = className;
    $[1] = data?.direction;
    $[2] = data?.secondColumn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const TwoColumnLayout = t0 => {
  const $ = _c(10);
  let T0;
  let children;
  let t1;
  let t2;
  if ($[0] !== t0) {
    const {
      data,
      as,
      children: t3,
      ...props
    } = t0;
    children = t3;
    const Component = as || "div";
    T0 = Component;
    t1 = props;
    t2 = clsx(props.className, "flex flex-col m:grid grid-cols-12 gap justify-between");
    $[0] = t0;
    $[1] = T0;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    T0 = $[1];
    children = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== T0 || $[6] !== children || $[7] !== t1 || $[8] !== t2) {
    t3 = <T0 {...t1} className={t2}>{children}</T0>;
    $[5] = T0;
    $[6] = children;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default Object.assign(TwoColumnLayout, {
  FirstColumn,
  SecondColumn
});